export const adPricing = {
    basic: 200000,      // 20만원
    standard: 500000,   // 50만원
    premium: 1000000    // 100만원
};

// 수수료 제거 — 월 구독 모델로 전환
// export const COMMISSION_RATE = 0.05;
// export const calculateCommission = (orderAmount) => orderAmount * COMMISSION_RATE;

// ===== IVAN 기공소 서비스 가격 =====

// 기공 서비스 단가
export const IVAN_SERVICE_PRICING = {
    zirconia_crown: {
        name: '지르코니아 크라운 (디자인+밀링)',
        basePrice: 50000,
        minPrice: 25000,
        category: 'crown',
        description: 'CAD 디자인 + CNC 밀링 + 소결',
        acceptedFileTypes: ['stl', 'odata'],
    },
    custom_abutment: {
        name: '커스텀 어버트먼트 (디자인+CNC)',
        basePrice: 50000,
        minPrice: 25000,
        category: 'implant',
        description: '커스텀 디자인 + CNC 가공',
        acceptedFileTypes: ['stl', 'odata'],
    },
};

// 멤버십 등급 (아이반 기공소 자체 멤버십 - 면세)
export const MEMBERSHIP_TIERS = [
    { percent: 0,  cost: 0,      label: '일반 (무멤버십)', description: '할인 없음' },
    { percent: 10, cost: 100000, label: '10% 할인',       description: '할인율 10%당 월 100,000원' },
    { percent: 20, cost: 200000, label: '20% 할인',       description: '30~50건 치과 추천' },
    { percent: 30, cost: 300000, label: '30% 할인',       description: '50~100건 치과 추천' },
    { percent: 40, cost: 400000, label: '40% 할인',       description: '100~200건 치과 추천' },
    { percent: 50, cost: 500000, label: '50% 할인',       description: '200건 이상 치과 추천' },
];

// 앱 구독료 (덴탈클러스터 - 과세) - 회원 유형별 차등
// 기본값: 기공소 (역호환성 유지). 동적 조회는 getAppSubscription(businessType) 사용
export const APP_SUBSCRIPTION = {
    monthlyFee: 30000,
    vatRate: 0.1,
    vatAmount: 3000,
    totalAmount: 33000,
    billingEntity: 'dentalcluster',
    billingType: 'taxed',
    invoiceType: '세금계산서',
    features: [
        '덴탈아리랑 365일 배너 홍보',
        '직접 방문 영업 + 전화 영업',
        '인스타그램 광고 집행',
        '주문·외주·채팅 운영 기능',
        '거래명세서 자동 발행',
        '실시간 유입 통계',
    ],
};

// 회원 유형별 구독 요금 상세
export const APP_SUBSCRIPTION_PRICING = {
    // 기공소: 월 33,000원(부가세 포함). 신규 가입 1개월 무료 체험 (약관 v6.2)
    lab: {
        monthlyFee: 30000,
        vatRate: 0.1,
        vatAmount: 3000,
        totalAmount: 33000,
        billingEntity: 'dentalcluster',
        billingType: 'taxed',
        invoiceType: '세금계산서',
        title: '기공소 구독 요금',
        // 1차(자동 거래명세서 서비스) 중심 구성 (2026-07-23)
        features: [
            { icon: '🤖', title: '덴클 에이전트 자동 수집', desc: 'CAD 작업 폴더를 자동 분석 — 환자명·치과·작업일을 알아서 인식' },
            { icon: '📝', title: '의뢰서 자동 등록', desc: '수집된 작업이 의뢰서로 자동 등록 — 하나하나 입력할 필요 없음' },
            { icon: '📄', title: '월말 거래명세서 자동 작성', desc: '치과를 고르면 그 달 수집분이 자동으로 채워집니다' },
            { icon: '💰', title: '단가 자동 완성', desc: '한 번 입력한 단가는 다음 달부터 자동 적용' },
            { icon: '🔁', title: '리메이크 자동 감지', desc: '재제작 건을 자동 표시 — 이중 청구·누락 방지' },
            { icon: '🧾', title: '전자세금계산서 연동 (준비 중)', desc: '확정된 명세서에서 클릭 한 번으로 세금계산서 발행 (준비 중입니다)' },   // 준비 중 표기 — 대표 지시 2026-10-04
        ],
    },
    // 치과: 월 99,000원(부가세 포함) — 약관 v6.2(2026-10-04 대표 결정). 신규 가입 치과부터 1개월 체험 후 적용,
    // 기존 치과(요금표 없음)는 별도 통지 시까지 무료 — 판정은 서버(billing-policy). 화면 금액은 서버 견적(getSubscriptionQuote) 우선, 이 값은 견적 로딩 전 표시용
    clinic: {
        monthlyFee: 90000,
        vatRate: 0.1,
        vatAmount: 9000,
        totalAmount: 99000,
        billingEntity: 'dentalcluster',
        billingType: 'taxed',
        invoiceType: '세금계산서',
        title: '치과 구독 요금',
        // 2026-08-21 대표 확정: 치과 구독 = 아래 기능 잠금 해제 (비구독 업체는 숨김/블러 — 시행일부터).
        // 이 목록이 잠금 대상의 정본 — 잠금 게이트 구현 시 이 배열을 기준으로 한다.
        features: [
            { icon: '📅', title: '도착 예정', desc: '오늘·내일 도착할 기공물과 예정일 지난 건을 한눈에' },
            { icon: '🏭', title: '작업 공정', desc: '내 환자 기공물이 스캔·디자인·밀링·포장 중 어디인지 실시간 확인' },
            { icon: '📷', title: '최근 스캔 (준비 중)', desc: '구강스캐너 스캔을 자동 인식 — 파일 찾고 옮길 필요 없음 (준비 중입니다)' },   // 치과 PC 프로그램 제외(10-04)로 미제공 — 법무 P1(결제 개시 전 표시 정리)
            { icon: '📑', title: '받은 명세서', desc: '월말 거래명세서가 자동으로 도착 — 대조·확인만 하면 끝' },
            // { icon: '🧾', title: '세금계산서 (준비 중)', desc: '받은 전자세금계산서 확인 — 명세서와 금액 자동 대조 (준비 중입니다)' },   // 준비 중 표기 — 대표 지시 2026-10-04
            //   ↑ 대표 10-15 "치과 세금계산서 (준비중) 이것도 빼줘" — 치과 메뉴 「받은 계산서」 숨김과 맞춤
            { icon: '✅', title: '정산 확인 (준비 중)', desc: '월별 명세서·계산서·수령 대조가 한 줄로 정리 (준비 중입니다)' },
            { icon: '📊', title: '기공비 분석', desc: '월별 기공비 추이·보철별 비중 — 감이 아니라 숫자로' },
            { icon: '🔁', title: '재제작 분석', desc: '재제작률·사유별 통계 — 품질 관리의 근거 자료' },
            // 덴클 프로그램 항목 제거 (대표 지시 2026-10-04 "덴클프로그램은 빼줘" — 치과 사이드메뉴 제거와 함께)
            // { icon: '🖥️', title: '덴클 프로그램', desc: '치과 PC 설치 — 스캔 자동 감지와 기공소 자동 전송' },
        ],
    },
};

// businessType 으로 구독 요금 조회 (핵심 helper)
export const getAppSubscription = (businessType) => {
    const isClinic = businessType === 'clinic' || businessType === 'dental' || businessType === '치과';
    return isClinic ? APP_SUBSCRIPTION_PRICING.clinic : APP_SUBSCRIPTION_PRICING.lab;
};

// 멤버십 등급별 단가 계산
export const calculateDiscountedPrice = (basePrice, tierPercent) => {
    return Math.round(basePrice * (100 - tierPercent) / 100);
};

// 멤버십 등급별 추천 물량
export const RECOMMENDED_TIER_BY_VOLUME = [
    { minVolume: 0,   maxVolume: 30,  recommendedTier: 0  },
    { minVolume: 30,  maxVolume: 50,  recommendedTier: 20 },
    { minVolume: 50,  maxVolume: 100, recommendedTier: 30 },
    { minVolume: 100, maxVolume: 200, recommendedTier: 40 },
    { minVolume: 200, maxVolume: Infinity, recommendedTier: 50 },
];

// 물량별 추천 등급 조회
export const getRecommendedTier = (monthlyVolume) => {
    const match = RECOMMENDED_TIER_BY_VOLUME.find(
        r => monthlyVolume >= r.minVolume && monthlyVolume < r.maxVolume
    );
    return match ? match.recommendedTier : 0;
};
// ===== 기공소 구독 플랜 3종 (2026-10-30 구독 플랜제 — 계획_구독플랜제_2026-10-30 §1, 대표 결정) =====
// 전 기능 활성화 + 지그 월 한도. 금액은 부가세 포함(공급가·VAT 는 화면 표시용). 정본 코드·금액은 utils/billingPolicy.TARIFFS(서버 billing-policy 미러).
// APP_SUBSCRIPTION(33,000원)은 옛 참조용으로 남긴다 — planV8At 이후 옛 요금표는 베이직으로 본다.
export const LAB_PLANS = [
    { code: 'lab_basic_55000_v8',     label: '베이직',   totalAmount: 55000,  monthlyFee: 50000,  vatAmount: 5000,  jigLimit: 300 },
    { code: 'lab_standard_110000_v8', label: '스탠다드', totalAmount: 110000, monthlyFee: 100000, vatAmount: 10000, jigLimit: 600 },
    { code: 'lab_premium_220000_v8',  label: '프리미엄', totalAmount: 220000, monthlyFee: 200000, vatAmount: 20000, jigLimit: 1200 },
];
